import * as React from 'react';
import * as styles from './styles.css';

import { IViewAllReportProps } from './types';
import { ReportItem } from './components/ReportItem';

export const ViewAllReport: React.FC<IViewAllReportProps> = props => {
  const { reportItems, currentReportItem, onItemClick } = props;

  return (
    <div data-testid="ViewAllReportId" className={styles['container']}>
      <ul className={styles['list']}>
        {reportItems.map(item => {
          return (
            <ReportItem
              key={item.id}
              onClick={() => onItemClick(item.id)}
              isActive={currentReportItem === item.id}
              label={item.name}
            />
          );
        })}
      </ul>
    </div>
  );
};

ViewAllReport.displayName = 'ViewAllReport';
